import { Component, OnInit, signal } from "@angular/core";
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.reducers';
import * as fromAuth from '../store/auth.reducers';
import * as AuthActions from '../store/auth.actions';
import { Observable, timer } from "rxjs";
import { SigninGeneralService } from "../../shared/signinGeneral.service";
import { first } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  standalone: false
})
export class SigninComponent implements OnInit {
  authState: Observable<fromAuth.State>;
  open_forgot_password = false;
  caps_locked_was_checked = false;
  email = '';
  in_signin = false;
  password = '';
  hasError = false;
  email_touched = false;
  image_list = signal<string[]>([]);

  constructor(private store: Store<AppState>, public generalService: SigninGeneralService,
              private httpClient: HttpClient) { }

  ngOnInit() {
    this.authState = this.store.select('auth');
    this.get_brands_icons();
    this.generalService.signin_set_additional_parameters(window.location.href);
  }

  onSignIn() {
    if (this.in_signin || this.open_forgot_password) {
      return;
    }
    this.in_signin = true;
    this.store.dispatch(new AuthActions.LoginStart({email: this.email, password: this.password}));
  }

  getColor() {
    this.in_signin=false;
    return 'red';
  }

  check_caps_lock(event: MouseEvent) {
    if (!this.email_touched) {
      const d = document.getElementById('email');
      if (d) {
        const email = d['value'];
        this.email = '';
        timer(.001).pipe(first()).subscribe({next: () => {
            d.style.fontSize = "12px";
            d.style.fontWeight = "550";
            d.style.color = "#b5c1ce";
            this.email_touched = true;
            this.email = email;
          }});
      }
    }
    if (!this.caps_locked_was_checked) {
      this.caps_locked_was_checked = true;
      this.generalService.capsLock = (event.getModifierState && event.getModifierState('CapsLock'));
    }
  }

  clearError() {
    if (this.hasError) {
      this.store.dispatch(new AuthActions.CloseError());
    }
  }

  show_error(): boolean {
    this.hasError = true;
    return true;
  }

  get_brands_icons() {
    this.httpClient.post<string[]>('tools/get_brands_icons',{}).subscribe({next: (ans: any) => {
        this.image_list.set(ans);
      }});
  }
}
